/** @jsx jsx */
import { jsx } from '@emotion/react'
import { lojaArabeStyles } from '../assets/styles/LojaArabe.styles'
import { Col, Container, Row } from 'react-bootstrap'
import { Fragment } from 'react'
import SliderLojaHome from '@/components/SliderLojaHome';

const LojaArabe = () => {
  return (
    <Fragment>
      <section css={lojaArabeStyles}>
        <Container>
          <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
            <Col lg={6} md={6} sm={12}>
              <h2>Identidade e pertencimento <span>no dia a dia</span></h2>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={5} md={5} sm={12}>
              <p>Vista-se com orgulho e tradição! Conforto, estilo e cultura em cada uniforme. Explore nossa coleção!</p>
            </Col>
          </Row>
        </Container>
      </section>
      <SliderLojaHome />
    </Fragment>
  )
}

export default LojaArabe;
